import React, { Component } from 'react';
import {
    Container,
    Col,
    Row,
    Button,
    Form,
    Input,
    Table,
    Modal,
    ModalBody,
    ModalFooter,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { Search } from '../components/Search';
import { OrdiniFilter } from '../components/StoricoOrdine/OrdiniFilter'


/**
 * Used for the Listino Prezzi section. 
 */
class StoricoOrdineContainer extends Component {

    constructor(props) {
        super(props);

        this.toggleOrdineModal = this.toggleOrdineModal.bind(this);

        this.state = {
            mesi: "Oggi",
            dropdownOpen: false,
            ordini: [],
            totalOrdini: 0,
            numPerPage: 5,
            totalPages: 0,
            changeNumPerPage: 0,
            pageNum: 1,
            searchText: "",
            dataDa: "",
            dataA: "",
            importoDa: "",
            importoA: "",
            codFisc: "",
            cliente: "",
            stato: "",
            ordineModal: false,
            ordineSelected: {},
            profOrdini: -3,
            ordinamento: "ordineIdD",
            erroreCliente: false,

            historicalFilter: {
                dataDa: "",
                dataA: "",
                importoDa: "",
                importoA: "",
                codFisc: "",
                cliente: "",
                stato: "",
            }
        };

    }

    componentDidMount() {
        this.getOrdini();
        console.log(this.state.dropdownOpen);
    }


    componentWillUnmount() {

    }

    getOrdini = () => {
        const form = {
            searchText: this.state.searchText,
            dataDa: this.state.dataDa,
            dataA: this.state.dataA,
            importoDa: this.state.importoDa,
            importoA: this.state.importoA,
            codFisc: this.state.codFisc,
            cliente: this.state.cliente,
            stato: this.state.stato,
            numPerPage: this.state.numPerPage,
            pageNum: this.state.pageNum,
            ordinamento: this.state.ordinamento,
            mesi: this.state.mesi
        }

        fetch(`../api/ordini/storico`, {
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json'
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
            .then(myjson => {
                if (myjson.statusCode) {
                    throw new Error("Empty")
                    console.log(Error)
                }
                this.setState({
                    ordini: myjson.ordini,
                    totalOrdini: myjson.totalOrdini,
                    totalPages: myjson.totalPages,
                    numPerPage: myjson.totalOrdini < this.state.numPerPage ? myjson.totalOrdini : this.state.numPerPage,
                    erroreCliente: false
                })
            }).catch(e => {
                this.setState({
                    erroreCliente: true
                })
            });
    }
    handleButtonChangeNumPerPage = (num) => {
        const newNumPerPage = ((this.state.numPerPage + num) > 0) && ((this.state.numPerPage + num) <= this.state.totalOrdini) ? (this.state.numPerPage + num) : this.state.numPerPage;

        if (newNumPerPage !== this.state.numPerPage) {
            this.setState({
                numPerPage: newNumPerPage,
                pageNum: newNumPerPage >= this.state.totalOrdini && this.state.pageNum !== 1 ? this.state.pageNum - 1 : this.state.pageNum
            }, () => this.getOrdini());
        }
        else if (this.state.numPerPage > this.state.totalOrdini) {
            if (num < 0) {
                this.setState({
                    numPerPage: this.state.numPerPage + num,
                });
            }

        }
    }

    handleInputChangeNumPerPage = (e) => {
        e.preventDefault(e);

        const isNum = /^\d+$/.test(e.target.value);

        if (isNum) {
            this.setState({
                numPerPage: parseInt(e.target.value, 10)
            });
        }
        else if (e.target.value === '') {
            this.setState({
                numPerPage: e.target.value,
            })
        }
    }

    handleNumPerPageSubmit = (e) => {
        e.preventDefault();

        if (this.state.numPerPage >= this.state.totalOrdini) {
            this.setState({
                pageNum: 1,
                numPerPage: this.state.totalOrdini
            }, () => this.getOrdini())
        }
        else {
            this.setState({
                pageNum: 1,
            }, () => this.getOrdini())
        }
    }

    handleSearchChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    handleOrdinamento = (ord) => {
        this.setState({
            ordinamento: ord,
            pageNum: 1
        }, () => this.getOrdini());
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();

        this.getOrdini();
    }

    handlePrev = (e) => {
        this.setState({
            pageNum: this.state.pageNum - 1
        }, () => this.getOrdini());
    }

    handleNext = (e) => {
        this.setState({
            pageNum: this.state.pageNum + 1
        }, () => this.getOrdini());
    }

    handleFilterChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleFilterCancel = () => {
        this.setState({
            dataDa: this.state.historicalFilter.dataDa,
            dataA: this.state.historicalFilter.dataA,
            importoDa: this.state.historicalFilter.importoDa,
            importoA: this.state.historicalFilter.importoA,
            codFisc: this.state.historicalFilter.codFisc,
            cliente: this.state.historicalFilter.cliente,
            stato: this.state.historicalFilter.stato,
        })
    }

    handleFilterSubmit = () => {

        this.setState({
            historicalFilter: {
                dataDa: this.state.dataDa,
                dataA: this.state.dataA,
                importoDa: this.state.importoDa,
                importoA: this.state.importoA,
                codFisc: this.state.codFisc,
                cliente: this.state.cliente,
                stato: this.state.stato,
            },
            numPerPage: this.state.pageNum >= 5 ? this.state.pageNum : 5
        }, () => this.getOrdini())
    }

    handleprofondita = (e) => {

        this.setState({
            mesi: e,
        }, () => this.getOrdini())
    }

    toggleOrdineModal = () => {
        this.setState({
            ordineModal: !this.state.ordineModal
        })
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    handleRiproponi = (id) => {

        fetch(`api/ordini/riproponi/${id}`, {
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json'
            }),
            //Sets the body of the call
            body: JSON.stringify()
            //Changes the response to an object
        })

        this.setState({
            ordineModal: !this.state.ordineModal
        })
    }




    handleOrdineSelected = (index) => {
        this.setState({
            ordineSelected: this.state.ordini[index]
        }, () => this.toggleOrdineModal())
    }
    /**
     * Renders the page
     */
    render() {
        const titolo = (
            <Container className="d-flex align-items-center justify-content-center" style={{ paddingBottom: "15px" }} fluid>
                <Row className="d-flex" style={{ margin: "0px", width: "100%" }}>
                    <Col xs={{ size: 12, order: 2 }} md={{ size: 3, order: 1 }} className="d-flex align-items-center justify-content-md-start justify-content-center pl-md-0 mb-2 mb-md-0" >
                        <Form className="form" onSubmit={this.handleNumPerPageSubmit}>
                            <Row className="d-flex align-items-center" >
                                <Col className=" d-flex justify-content-end col-4" style={{ padding: "0px", marginRight: "0px", height: "40px" }}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(-1)} style={{ height: "100%", width: "100%", padding: "0px", borderTopLeftRadius: "25px", borderWidth: "medium", borderBottomLeftRadius: "25px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderRight: "0px", fontSize: "25px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>-</Button>
                                </Col>
                                <Col className="d-flex justify-content-center col-4" style={{ padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px" }}>
                                    {this.state.totalOrdini === 0 ?
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{ width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} /> :
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{ width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />}
                                </Col>
                                <Col className=" d-flex justify-content-start col-4" style={{ padding: "0px", marginRight: "0px", height: "40px" }}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(1)} style={{ height: "100%", width: "100%", padding: "0px", borderWidth: "medium", borderTopRightRadius: "25px", borderBottomRightRadius: "25px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderLeft: "0px", fontSize: "25px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>+</Button>
                                </Col>

                            </Row>
                        </Form>
                    </Col>
                    <Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 2 }} className="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                        <h5 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Storico Ordini</h5><div>&nbsp;&nbsp;</div>
                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <DropdownToggle style={{ backgroundColor: "#011e41", paddingTop: "2px", paddingBottom: "2px", fontSize: "20px" }} caret>
                                {this.state.mesi}
                            </DropdownToggle>
                            <DropdownMenu modifiers={{
                                setMaxHeight: {
                                    enabled: true,
                                    order: 890,
                                    fn: (data) => {
                                        return {
                                            ...data,
                                            styles: {
                                                ...data.styles,
                                                overflow: 'auto',
                                                maxHeight: "25vh",
                                            },
                                        };
                                    },
                                },
                                computeStyle: {
                                    gpuAcceleration: false
                                }
                            }}>
                                <DropdownItem onClick={() => this.handleprofondita("Oggi")}>Oggi</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("Settimana")}>Settimana</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("1 mese")}>1 mese</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("3 mesi")}>3 mesi</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("6 mesi")}>6 mesi</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("12 mesi")}>12 mesi</DropdownItem>
                                <DropdownItem onClick={() => this.handleprofondita("Completo")}>Completo</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                    <Col xs={{ size: 12, order: 3 }} md={{ size: 3, order: 3 }} className="d-flex align-items-center justify-content-md-end justify-content-center pr-md-0" >
                        <Container>
                            <Row style={{ marginBottom: "5px" }}>
                                <Col>
                                    <Search text={this.state.searchText} handleSearchChange={this.handleSearchChange} handleSearchSubmit={this.handleSearchSubmit} />
                                </Col>
                            </Row>

                            <Row>
                                <Col style={{ padding: "0" }}>
                                    <OrdiniFilter annulla={this.handleFilterCancel} vai={this.handleFilterSubmit}>
                                        <Container>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{ color: "#011e41", fontWeight: "bold", fontSize: "35px", margin: "0px" }}>Data:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginBottom: "5px", height: "90%" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>da:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="dataDa" name="dataDa" type="date" onChange={this.handleFilterChange} value={this.state.dataDa} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row style={{ borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px", height: "90%" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>a:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="dataA" name="dataA" type="date" onChange={this.handleFilterChange} value={this.state.dataA} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{ color: "#011e41", fontWeight: "bold", fontSize: "35px", margin: "0px" }}>Importo:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginBottom: "5px" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>da:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="importoDa" name="importoDa" type="number" onChange={this.handleFilterChange} value={this.state.importoDa} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row style={{ borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>a:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="importoA" name="importoA" type="number" onChange={this.handleFilterChange} value={this.state.importoA} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{ color: "#011e41", fontWeight: "bold", fontSize: "35px", margin: "0px" }}>Cliente:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginBottom: "5px" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Codice Fiscale:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="codFisc" name="codFisc" type="text" onChange={this.handleFilterChange} value={this.state.codFisc} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row style={{ borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Cliente:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="cliente" name="cliente" type="text" onChange={this.handleFilterChange} value={this.state.cliente} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{ color: "#011e41", fontWeight: "bold", fontSize: "35px", margin: "0px" }}>Stato:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginBottom: "5px" }}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Stato:</h4>
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="stato" name="stato" type="text" onChange={this.handleFilterChange} value={this.state.stato} style={{ height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />
                                                </Col>
                                            </Row>
                                        </Container>
                                    </OrdiniFilter>

                                </Col>
                            </Row>
                        </Container>

                    </Col>
                </Row>
            </Container>
        );

        const navFooter = (
            <Container className="d-flex align-items-center justify-content-center" style={{ padding: "0px", paddingBottom: "15px" }} fluid>
                <Row style={{ margin: "0px", width: "100%" }}>
                    <Col className="d-flex align-items-center justify-content-start col-6" style={{ paddingLeft: "0px", color: "#011e41" }}>
                        {this.state.totalOrdini !== 0 ? "Mostra da " + ((this.state.numPerPage * (this.state.pageNum - 1)) + 1) + " a " + (this.state.numPerPage * this.state.pageNum <= this.state.totalOrdini ? this.state.numPerPage * this.state.pageNum : this.state.totalOrdini) + " di " + this.state.totalOrdini + " risultati" : null}
                    </Col>
                    <Col className="d-flex align-items-center justify-content-end col-6" style={{ paddingLeft: "0px", color: "#011e41" }}>
                        {this.state.pageNum === 1 ? null : <a style={{ paddingRight: "10px", cursor: "pointer" }} onClick={this.handlePrev}>Indietro</a>}
                        {(this.state.pageNum === 1 && this.state.pageNum === this.state.totalOrdini) || this.state.totalOrdini === 0 ? null : this.state.pageNum}
                        {(this.state.pageNum === this.state.totalPages) || this.state.totalOrdini === 0 ? <p style={{ paddingLeft: "35px" }}></p> : <a style={{ paddingLeft: "10px", cursor: "pointer" }} onClick={this.handleNext}>Avanti</a>}
                    </Col>
                </Row>
            </Container>
        );

        return (
            <Container fluid style={{ color: "#011e41" }}>
                {titolo}
                <Container>
                    <Row>
                        <Col>
                            <Table responsive borderless>
                                <thead>
                                    <tr style={{ borderBottom: "1px solid #011e41" }}>
                                        <th style={{ textAlign: "center" }}>Ordine ID
                                            <Button onClick={() => this.handleOrdinamento("ordineId")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("ordineIdD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button></th>
                                        <th style={{ textAlign: "center" }}>Codice Cliente
                                            <Button onClick={() => this.handleOrdinamento("codiceCliente")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("codiceClienteD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button></th>
                                        <th style={{ textAlign: "center" }}>Cliente
                                            <Button onClick={() => this.handleOrdinamento("ragSoc")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("ragSocD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button></th>
                                        <th style={{ textAlign: "center" }}>Stimato</th>
                                        <th style={{ textAlign: "center" }}>Data Ordine
                                            <Button onClick={() => this.handleOrdinamento("dataInserisci")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("dataInserisciD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button></th>
                                        <th style={{ textAlign: "center" }}>Agente
                                            <Button onClick={() => this.handleOrdinamento("agente")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("agenteD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button></th>
                                        <th style={{ textAlign: "center" }}>Stato</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ordini == null || this.state.ordini.length == 0 ?
                                        <td colspan="8" style={{ padding: "5px", textAlign: "center" }}> Nessun ordine trovato</td> :
                                        this.state.ordini.map((ordine, index) => {
                                            return (
                                                <tr key={ordine.ordineId}>
                                                    <td style={{ padding: "5px", textAlign: "center" }}><a onClick={() => this.handleOrdineSelected(index)} style={{ color: 'blue', cursor: 'pointer' }}>{ordine.ordineId}</a></td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>{ordine.cliente.codiceCliente}</td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>{ordine.cliente.ragSoc}</td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>€ {ordine.stimato}</td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>{new Date(ordine.dataInserici).toLocaleDateString()}</td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>{ordine.agente}</td>
                                                    <td style={{ padding: "5px", textAlign: "center" }}>{ordine.status}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                            {/* {this.state.ordini.length > 0 ?
                                new Date(this.state.ordini[0].dataInserici).toLocaleDateString()
                                : null
                            } */}
                        </Col>
                    </Row>
                </Container>
                {navFooter}
                <Modal size="xl" isOpen={this.state.ordineModal} toggle={this.toggleOrdineModal} style={{ fontSize: "22px", color: "#011e41" }}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Ordine Id:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {this.state.ordineSelected.ordineId}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Agente:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {this.state.ordineSelected.agente}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Data Ordine:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {new Date(this.state.ordineSelected.dataInserici).toLocaleDateString()}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Approvato da:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {this.state.ordineSelected.approvatoDa}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Data Approvazione:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {new Date(this.state.ordineSelected.dataApprovato).toLocaleDateString()}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Data di Consegna:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {new Date(this.state.ordineSelected.dataDiConsegna).toLocaleDateString()}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start" sm={4}>
                                    Note:
                                </Col>
                                <Col className="d-flex justify-content-start" sm={8}>
                                    {this.state.ordineSelected.note}
                                </Col>
                            </Row>
                        </Container>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row style={{ width: '100%' }}>
                                <Col className="d-flex justify-content-start">
                                    <Table responsive borderless style={{ fontSize: "21px" }}>
                                        <thead>
                                            <tr style={{ borderBottom: "1px solid #011e41" }}>
                                                <th style={{ textAlign: "center" }}>Articolo ID</th>
                                                <th style={{ textAlign: "center" }}>Descrizione</th>
                                                <th style={{ textAlign: "center" }}>Quantità</th>
                                                <th style={{ textAlign: "center" }}>Prezzo</th>
                                                <th style={{ textAlign: "center" }}>Sconto1</th>
                                                <th style={{ textAlign: "center" }}>Sconto2</th>
                                                <th style={{ textAlign: "center" }}>Importo (Stimato)</th>
                                                <th style={{ textAlign: "center" }}>Note</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ordineSelected.ordineId ?
                                                this.state.ordineSelected.articoli.map((articolo, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.articoloId}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.descrizione}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.quantita}/{articolo.um}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>€ {articolo.prezzoA}Kg</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.sconto1}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.sconto2}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>€ {articolo.stimato}</td>
                                                            <td style={{ padding: "5px", textAlign: "center" }}>{articolo.note}</td>
                                                        </tr>
                                                    )
                                                }) : null}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.handleRiproponi(this.state.ordineSelected.ordineId)}>
                                Riproponi
                            </Button>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={this.toggleOrdineModal}>
                                Chiudi
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container>
        )
    }
}

export default withRouter(StoricoOrdineContainer)


// WEBPACK FOOTER //
// ./src/containers/StoricoOrdineContainer.js